import { StandardAlert } from 'component/StandardAlert';
import StyleItem from 'component/style_item';
import UserType from 'constants/user';
import { useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import styleItemUtils from 'utils/style_item';
import noStyleIcon from '../../assets/svg/no_style_v2.svg';
import './style.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { STRINGS } from '../../constants';
import { Virtual } from 'swiper/modules';
const FeedContainer = ({
    handleChangeSlide,
    heightContent,
    handleViewDetail,
    listStyle,
    handleClick,
    handleViewInfo,
    handleSendMessageWA,
    handleTrackView,
    inputSearch,
    isSearch,
    userDetail,
    handleClickStylist,
    handleExternalChangeSlide,
    setSwiperInstance,
    handleLastResult,
}) => {
    const handleRefreshStyle = (user) => {
        handleClickStylist(user);
        handleExternalChangeSlide(0);
    };

    const location = useLocation();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const isDiscoverStylesPage = !user && location.pathname.includes(PATH.DISCOVER_YOUR_STYLE) ? true : false;
    const height = isDiscoverStylesPage ? heightContent - 80 : heightContent;

    return (
        <div>
            <div
                className="itemRecommend-slider"
                style={{
                    maxHeight: `${height}px`,
                }}
            >
                <Swiper
                    direction="vertical"
                    modules={[Virtual]}
                    virtual
                    height={heightContent}
                    onSlideChange={handleChangeSlide}
                    onSwiper={setSwiperInstance}
                    mousewheel={true}
                    slidesPerView={isDiscoverStylesPage ? 1.1 : 1}
                    slidesOffsetAfter={isDiscoverStylesPage ? 60 : 0}
                >
                    {listStyle.map((item, index) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const info = styleItemUtils.getInfo(item);
                        // console.debug("FeedSlider.item=", item, info);
                        return (
                            <SwiperSlide key={`${item.id}_${index}`} virtualIndex={index}>
                                <StyleItem
                                    inputSearch={inputSearch}
                                    styleItemData={
                                        item.collection === 'items'
                                            ? { items: [{ data: item, id: item.id }], ...item }
                                            : item
                                    }
                                    heightContent={height}
                                    handleViewDetail={handleViewDetail}
                                    handleClick={handleClick}
                                    handleAddtobag={handleViewDetail}
                                    handleViewInfo={handleViewInfo}
                                    handleSendMessageWA={handleSendMessageWA}
                                    setTitle={() => null}
                                    handleClickStylist={() => handleRefreshStyle(item?.user)}
                                    itemIndex={item?.sliderIndex ?? 0}
                                    isItemOnly={item.collection === 'items'}
                                />
                            </SwiperSlide>
                        );
                    })}
                    {userDetail?.userType !== UserType.Stylist && (
                        <SwiperSlide>
                            <div style={{ height: '100%', padding: '30px 24px 0' }}>
                                <StandardAlert
                                    height={`calc( ${heightContent}px - 100px)`}
                                    icon={noStyleIcon}
                                    title={
                                        location.pathname === PATH.PERSONALIZED_STYLES
                                            ? STRINGS.WANT_MORE_PERSONALIZED_STYLE
                                            : location.pathname === PATH.USER_DISLIKES ||
                                              location.pathname === PATH.USER_LIKES
                                                ? STRINGS.NO_MORE_STYLES
                                                : STRINGS.DID_NOT_LIKE_STYLE
                                    }
                                    body={
                                        location.pathname === PATH.PERSONALIZED_STYLES
                                            ? STRINGS.ASK_AMIRA_FOR_PERSONALIZED_STYLE
                                            : location.pathname === PATH.USER_DISLIKES ||
                                              location.pathname === PATH.USER_LIKES
                                                ? STRINGS.CHECKOUT_NEW_STYLES_MESSAGE
                                                : STRINGS.ASK_AMIRA_FOR_PERSONALIZED_STYLE
                                    }
                                    isNoStyle={true}
                                    onButtonClick={handleLastResult}
                                    buttonClickOnWidget={handleLastResult}
                                    buttonText={
                                        location.pathname === PATH.USER_DISLIKES ||
                                        location.pathname === PATH.USER_LIKES
                                            ? STRINGS.CHECKOUT_NEW_STYLES
                                            : STRINGS.ASK_AMIRA_NOW
                                    }
                                    isIcon={false}
                                />
                                {/* ToDo: prompt customer to update style preferences ? or if /recommendations then suggest search ? */}
                            </div>
                        </SwiperSlide>
                    )}
                </Swiper>
            </div>
        </div>
    );
};
export default FeedContainer;
